//========================================================================================
/*

  goal          [obj]
  cellType      [str]
 
 */
//========================================================================================


import React from 'react';
import moment from 'moment';
import { translate } from 'react-i18next';

const BodyCell = (props) => {
  const { goal, cellType, t } = props;
  const cellDataArr = Array.isArray(goal.logs) && goal.logs.filter(log => log.type === cellType);

  if (Array.isArray(cellDataArr) && cellDataArr.length) {
    const sortByDate = cellDataArr.sort((a, b) => new Date(b.createAt).getTime() - new Date(a.createAt).getTime());

    return Array.isArray(sortByDate) && sortByDate[0] ?
      <td className={sortByDate[0].status && sortByDate[0].status.toLowerCase()}>
        {sortByDate[0].status || t('no_data')}
        <p className="sub-title">{sortByDate[0].createAt && moment(sortByDate[0].createAt).format('DD.MM.YYYY HH:mm') || t('no_data')}</p>
      </td>
      : null;

  }
  return null;
};

export default translate()(BodyCell);